'use strict';

var icon = require('../../../../../../../../../../_virtual/icon3.cjs');

var hasRequiredIcon;

function requireIcon () {
	if (hasRequiredIcon) return icon.__exports;
	hasRequiredIcon = 1;

	var ICON_AVIARY_SIZES = /*#__PURE__*/ function(ICON_AVIARY_SIZES) {
	    ICON_AVIARY_SIZES["xsmall"] = "xsmall";
	    ICON_AVIARY_SIZES["small"] = "small";
	    ICON_AVIARY_SIZES["medium"] = "medium";
	    ICON_AVIARY_SIZES["large"] = "large";
	    return ICON_AVIARY_SIZES;
	}({});

	icon.__exports.ICON_AVIARY_SIZES = ICON_AVIARY_SIZES;
	
	return icon.__exports;
}

exports.__require = requireIcon;
//# sourceMappingURL=icon.cjs.map
